/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/prop-types */
import React from 'react';
import { Dialog, Typography } from '@oca/ui';

export function MobileComingSoonModal({ onClose }) {
  return (
    <Dialog
      title="Information"
      onClose={onClose}
      underlayStyle={{
        backgroundColor: 'rgba(240, 240, 240, 1)',
      }}
    >
      <div style={{ padding: 20, textAlign: 'center' }}>
        <Typography
          fontSize={18}
          align="center"
          color="text"
          style={{ marginBottom: 8 }}
          fontWeight={500}
        >
          Mobile Version Coming Soon!
        </Typography>

        <Typography fontSize={14} align="center" color="textSecondary">
          We're preparing a better mobile experience. <br /> Thank you for your
          patience!
        </Typography>
      </div>
    </Dialog>
  );
}
